import React from 'react';
import { PROFESSIONAL_COUNTS } from '../../hooks/useSignupWizard';

interface StepProfessionalsProps {
    formData: {
        professionalCount: string;
    };
    updateFormData: (data: { professionalCount: string }) => void;
    onNext: () => void;
    onBack: () => void;
    error: string | null;
}

const StepProfessionals: React.FC<StepProfessionalsProps> = ({
    formData,
    updateFormData,
    onNext,
    onBack,
    error
}) => {
    const handleSelect = (count: string) => {
        updateFormData({ professionalCount: count });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onNext();
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="text-center mb-8">
                <p className="text-sm text-primary font-medium mb-2">Informações adicionais</p>
                <h2 className="text-2xl font-bold text-gray-900">Número de profissionais que fazem atendimento em seu negócio</h2>
            </div>

            {error && (
                <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    {error}
                </div>
            )}

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {PROFESSIONAL_COUNTS.map((option) => (
                    <button
                        key={option.id}
                        type="button"
                        onClick={() => handleSelect(option.id)}
                        className={`
                            p-4 rounded-xl border-2 transition-all hover:shadow-md text-center
                            ${formData.professionalCount === option.id
                                ? 'border-primary bg-primary/5'
                                : 'border-gray-200 hover:border-gray-300'
                            }
                        `}
                    >
                        <span className="text-sm font-medium text-gray-700">
                            {option.label}
                        </span>
                    </button>
                ))}
            </div>

            <button
                type="submit"
                disabled={!formData.professionalCount}
                className="w-full py-3 px-4 bg-primary hover:bg-primary-dark text-white font-semibold rounded-xl transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Continuar
            </button>
        </form>
    );
};

export default StepProfessionals;
